var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._b(
      {
        attrs: {
          remote: true,
          filterable: "",
          "reserve-keyword": "",
          placeholder: _vm.placeholder,
          "remote-method": _vm.search,
          loading: _vm.loading,
          clearable: _vm.clearable,
        },
        on: { "visible-change": _vm.visibleChange },
        model: {
          value: _vm.selfValue,
          callback: function ($$v) {
            _vm.selfValue = $$v
          },
          expression: "selfValue",
        },
      },
      "el-select",
      _vm.config,
      false
    ),
    [
      !_vm.loading
        ? _c("i", {
            staticClass: "el-icon-search",
            attrs: { slot: "prefix" },
            slot: "prefix",
          })
        : _vm._e(),
      _vm._l(_vm.rows, function (item) {
        return _c(
          "el-option",
          {
            key: item.id,
            attrs: {
              value: item.id,
              label: (item.name ? item.name + " - " : "") + item.mobile,
            },
          },
          [
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c("span", [_vm._v(_vm._s(item.name))]),
              _c("small", [_vm._v(_vm._s(item.mobile))]),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }